import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { unsafeUseFormReturnSubset } from '@ipfabric/ui-components/utils/formSnippets/unsafeUseFormReturnSubset';
import {
  type VendorsApiFieldValues,
  storedVendorsApi,
} from 'app/features/DiscoverySettingsForms/snippets/storedVendorsApi';
import { VendorsApi } from '../../../components/Authentication/VendorsApi';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const vendorsApiGroup = createFormSnippetGroup({
  snippets: {
    storedVendorsApi,
  },
  render: ({ renderSnippet, form }) => (
    <SearchableSection
      className='flex flex-col flex-1'
      wrapperClassName='flex flex-col flex-1'
      id='vendor-apis'
    >
      <VendorsApi
        form={unsafeUseFormReturnSubset(form)<keyof VendorsApiFieldValues>()}
        renderSnippet={renderSnippet}
      />
    </SearchableSection>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('authentication');
    control.setAuthenticationSubTab('vendors');
  },
});
